/* eslint-disable max-len */
/* eslint-disable react/display-name */
import { VoidCallback, VoidCallback1 } from '@deqo/foundation';
import React from 'react';
import { LFC } from '../../../Legacy';
import { ContentGrid, Copy, Spacer } from '../../dashboard/elements/LayoutElements';
import { Popup } from '../../popups/Popup';
import { Button } from './../../../ui';
import { TabularData, TabularImportParams, TabularImportStrategy } from './TabularImportModel';
import { IndexCardsTabularImportStrategy } from './strategies/IndexCardsTabularImportStrategy';
import { StickiesInTopicsTabularImportStrategy } from './strategies/StickiesInTopicsTabularImportStrategy';
import { StickiesInZonesTabularImportStrategy } from './strategies/StickiesInZonesTabularImportStrategy';
import { StickiesTabularImportStrategy } from './strategies/StickiesTabularImportStrategy';
import { TaskCardsTabularImportStrategy } from './strategies/TaskCardsTabularImportStrategy';
import { TokensTabularImportStrategy } from './strategies/TokensTabularImportStrategy';

const { Item, ItemHeading, ItemBorder, ItemInfo } = ContentGrid;

const strats = [
    StickiesTabularImportStrategy,
    IndexCardsTabularImportStrategy,
    TokensTabularImportStrategy,
    TaskCardsTabularImportStrategy,
    // DraftJiraCardsTabularImportStrategy,
    // RoadmapCardTabularImportStrategy,
    StickiesInZonesTabularImportStrategy,
    StickiesInTopicsTabularImportStrategy,
    // [null, TextScene] as const,
];

const determineActionLabel = (params: TabularImportParams) => {
    if (params.method === 'clipboard') return 'pasting';
    if (params.method === 'dragdrop') return 'dropping';
    return 'adding';
};

const determineFormatLabel = (params: TabularImportParams) => {
    if (params.mimeType === 'text/html') return 'a table from a document or web page';
    if (params.mimeType === 'text/csv') return 'CSV data';
    return 'tabular data';
};

export type TabularImportStrategySelectMenuProps = {
    data: TabularData,
    initialParams?: TabularImportParams,
    onSelect: VoidCallback1<TabularImportStrategy>,
    onCancel: VoidCallback,
};

export const TabularImportStrategySelectMenu: LFC<TabularImportStrategySelectMenuProps> = ({ initialParams, onSelect, onCancel }) => {

    return <>
        <Popup.Content>
            <Copy>
                The content you are {determineActionLabel(initialParams)} looks like {determineFormatLabel(initialParams)}.
                How would you like to import this data?
            </Copy>
            <Spacer f={1} />
            <ContentGrid layout={[14.5, 12, .5]}>
                {strats.map(st =>
                    <Item key={st.id} onClick={() => onSelect(st)}>
                        <ItemHeading>{st.label}</ItemHeading>
                        <ItemBorder bg={`url(${st.image})`} />
                    </Item>
                )}
            </ContentGrid>
        </Popup.Content>
        <Popup.Actions>
            <Button onAction={onCancel}>
                Cancel
            </Button>
        </Popup.Actions>
    </>;
};
